"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconBackToTop', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.8 4H3.19998C2.75758 4 2.39998 3.6424 2.39998 3.2C2.39998 2.7576 2.75758 2.4 3.19998 2.4H12.8C13.2424 2.4 13.6 2.7576 13.6 3.2C13.6 3.6424 13.2424 4 12.8 4ZM7.43438 7.4344C7.74718 7.1216 8.25278 7.1216 8.56558 7.4344L13.3656 12.2344C13.6784 12.5472 13.6784 13.0528 13.3656 13.3656C13.2096 13.5216 13.0048 13.6 12.8 13.6C12.5952 13.6 12.3904 13.5216 12.2344 13.3656L7.99998 9.1312L3.76558 13.3656C3.45278 13.6784 2.94718 13.6784 2.63438 13.3656C2.32158 13.0528 2.32158 12.5472 2.63438 12.2344L7.43438 7.4344Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M16 5H4.00001C3.44701 5 3.00001 4.553 3.00001 4C3.00001 3.447 3.44701 3 4.00001 3H16C16.553 3 17 3.447 17 4C17 4.553 16.553 5 16 5ZM9.29301 9.293C9.68401 8.902 10.316 8.902 10.707 9.293L16.707 15.293C17.098 15.684 17.098 16.316 16.707 16.707C16.512 16.902 16.256 17 16 17C15.744 17 15.488 16.902 15.293 16.707L10 11.414L4.70701 16.707C4.31601 17.098 3.68401 17.098 3.29301 16.707C2.90201 16.316 2.90201 15.684 3.29301 15.293L9.29301 9.293Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M19.2 6H4.79997C4.13637 6 3.59997 5.4636 3.59997 4.8C3.59997 4.1364 4.13637 3.6 4.79997 3.6H19.2C19.8636 3.6 20.4 4.1364 20.4 4.8C20.4 5.4636 19.8636 6 19.2 6ZM11.1516 11.1516C11.6208 10.6824 12.3792 10.6824 12.8484 11.1516L20.0484 18.3516C20.5176 18.8208 20.5176 19.5792 20.0484 20.0484C19.8144 20.2824 19.5072 20.4 19.2 20.4C18.8928 20.4 18.5856 20.2824 18.3516 20.0484L12 13.6968L5.64837 20.0484C5.17917 20.5176 4.42077 20.5176 3.95157 20.0484C3.48237 19.5792 3.48237 18.8208 3.95157 18.3516L11.1516 11.1516Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M25.6 7.99999H6.40002C5.51522 7.99999 4.80002 7.28479 4.80002 6.39999C4.80002 5.51519 5.51522 4.79999 6.40002 4.79999H25.6C26.4848 4.79999 27.2 5.51519 27.2 6.39999C27.2 7.28479 26.4848 7.99999 25.6 7.99999ZM14.8688 14.8688C15.4944 14.2432 16.5056 14.2432 17.1312 14.8688L26.7312 24.4688C27.3568 25.0944 27.3568 26.1056 26.7312 26.7312C26.4192 27.0432 26.0096 27.2 25.6 27.2C25.1904 27.2 24.7808 27.0432 24.4688 26.7312L16 18.2624L7.53122 26.7312C6.90562 27.3568 5.89442 27.3568 5.26882 26.7312C4.64322 26.1056 4.64322 25.0944 5.26882 24.4688L14.8688 14.8688Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;